import { createApp } from 'vue'
import VueNumber from "vue-number-animation";

import VueWooSearch from './VueWooSearch.vue';
import VueProductNavBar from './VueWooProductNavBar.vue';


const searchApp = createApp(VueWooSearch)
const productNavApp = createApp(VueProductNavBar)
// const productList = createApp(VueWooProducts)

productNavApp.use(VueNumber);

searchApp.mount('#shopSearch')
productNavApp.mount('#productNav')